import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

import withAuthGuard from '../../withAuthGuard';

import ChangeAddOn from '../../../components/ChangeAddOn';
import { selectActivePlanSubscription, selectAvailableAddOns, selectProducts } from '../../../queries/selectors/products';
import { selectSubscriptionsEntities, selectAddOnSubscriptions } from '../../../queries/selectors/bootstrap';
import { requestAsync } from '../../../queries/actions';
import { downgradeAddOnSubscriptions, upgradeAddOnSubscriptions } from '../../../queries/subscription';
import withMembershipGuard from '../../withMembershipGuard';
import withNoAvailableProducts from '../../withNoAvailableProducts';
import { getPaymentMethodRequest } from '../../../queries/payment';
import withMembershipPurchased from '../../withMembershipPurchased';
import { selectClient } from '../../../global-selectors';
import { selectCurrentPaymentMethod } from '../../../queries/selectors/payment';
import { selectUserData } from '../../../queries/selectors/user';
import { injectIntl } from 'react-intl';

import { connectRequest } from '../../../utils/query';
import { getProductsToBuy, selectAddOnsToShow } from '../../../queries/selectors/shoppingCart';
import { addProduct, setAddOnsToShow } from '../../../queries/actions/shoppingCart';
import { applyProductRules } from '../../../queries/actions/rules';

const mapStateToProps = (state) => {
  return {
    userPlan: selectActivePlanSubscription(state),
    client: selectClient(state),
    user: selectUserData(state),
    methodId: selectCurrentPaymentMethod(state),
    addOnList: selectAvailableAddOns(state),
    subscriptions: selectSubscriptionsEntities(state),
    addOnSubscriptions: selectAddOnSubscriptions(state),
    products: selectProducts(state),
    productsToBuy: getProductsToBuy(state),
    addOnsToShow: selectAddOnsToShow(state),
    currentPaymentMethod: selectCurrentPaymentMethod(state),
  }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  upgradeAddOnSubscriptions: (data) => requestAsync(upgradeAddOnSubscriptions, data),
  downgradeAddOnSubscriptions: (data) => requestAsync(downgradeAddOnSubscriptions, data),
  applyProductRules: (data) => applyProductRules(data),
  addProduct: (data) => addProduct(data),
  setAddOnsToShow: payload => setAddOnsToShow(payload),
}, dispatch);

const mapPropsToConfigs = (props) => [
  getPaymentMethodRequest(props),
];

export default compose(
  injectIntl,
  withMembershipGuard,
  withMembershipPurchased,
  connect(mapStateToProps, mapDispatchToProps),
  withAuthGuard({ toLoginURL: true }),
  connectRequest(mapPropsToConfigs),
  withNoAvailableProducts('addOn')
)(ChangeAddOn);
